import { useLayoutEffect } from "react";
import { useParallaxController } from "react-scroll-parallax";

const ParallaxCache = () => {
    const { parallaxController } = useParallaxController() || {};

    useLayoutEffect(() => {
        if (typeof window === 'undefined' || !parallaxController) return;
        
        const handler = () => parallaxController.update();
        window.addEventListener('load', handler);
        return () => window.removeEventListener('load', handler);
    }, [parallaxController]);

    return null;
};

export default ParallaxCache;
